import {
  endOfMonth,
  endOfWeek,
  startOfMonth,
  startOfQuarter,
  startOfWeek,
  subDays,
  subMonths,
  subWeeks,
} from 'date-fns';

export const FLOW_ANALYTICS_FLAG = 'flow-metrics';
export const FLOW_APPROVAL_FEATURE_FLAG = 'flow-approval-process';
export const FLOW_COLLECTIONS_FEATURE_FLAG = 'flow-collections';
export const FLOW_FILTERS_FEATURE_FLAG = 'pi-6-flow-filters-in-omnibar';
export const FLOW_LAST_ACTIVITY_AT_FLAG = 'pi-5-last-activity';

export const FLOW_USAGE_METRICS = [
  { key: 'HIGH_USAGE', value: 'HIGH_USAGE', text: 'High usage' },
  { key: 'MEDIUM_USAGE', value: 'MEDIUM_USAGE', text: 'Medium usage' },
  { key: 'LOW_USAGE', value: 'LOW_USAGE', text: 'Low usage' },
];

export const FLOW_ENGAGEMENT_METRICS = [
  { key: 'HIGH_ENGAGEMENT', value: 'HIGH_ENGAGEMENT', text: 'High engagement' },
  {
    key: 'MEDIUM_ENGAGEMENT',
    value: 'MEDIUM_ENGAGEMENT',
    text: 'Medium engagement',
  },
  { key: 'LOW_ENGAGEMENT', value: 'LOW_ENGAGEMENT', text: 'Low engagement' },
];

export const FLOW_CONVERSION_METRICS = [
  { key: 'HIGH_CONVERSION', value: 'HIGH_CONVERSION', text: 'High conversion' },
  {
    key: 'MEDIUM_CONVERSION',
    value: 'MEDIUM_CONVERSION',
    text: 'Medium conversion',
  },
  { key: 'LOW_CONVERSION', value: 'LOW_CONVERSION', text: 'Low conversion' },
];

export const FLOW_STATUS = [
  { key: 'NEW_ACTIVE', value: 'NEW_ACTIVE', text: 'Active' },
  { key: 'ARCHIVED', value: 'ARCHIVED', text: 'Archived' },
  { key: 'ALL', value: 'ALL', text: 'All' },
];
export const FLOW_APPROVAL_STATUS = [
  { key: 'DRAFT', value: 'DRAFT', text: 'Draft' },
  { key: 'PENDING', value: 'PENDING', text: 'Pending Review' },
];
export const FLOW_SORT_BY = {
  name: 'Name',
  created_at: 'Created date',
  updated_at: 'Last updated date',
  starred: 'Favorites',
};
export const FLOW_ANALYTICS_SORT_BY = {
  last_activity_at: 'Last activity date',
  usage_perc: 'Usage',
  engagement_perc: 'Engagement',
  conversion_perc: 'Conversion',
};

export type MultiSelectItem = { key: string | number; text: string };
export type FlowSortBy =
  | 'name'
  | 'created_at'
  | 'updated_at'
  | 'last_activity_at'
  | 'usage'
  | 'conversion'
  | 'engagement'
  | 'starred';
export type FlowSortDirection = 'ASC' | 'DESC';
export type FlowFiltersKey = keyof FlowFilters;
export type DateRange = { startDate: Date | null; endDate: Date | null };
export type FlowFilters = {
  searchTerm: string | null;
  isStarred: boolean | null;
  isDueActions: boolean | null;
  isActivePeople: boolean | null;
  statuses: string[] | null;
  labels: number[] | string[];
  collections: number[];
  collectionItems: MultiSelectItem[];
  ownerIds: number[];
  ownerItems: MultiSelectItem[];
  sharedWith: string[];
  sharedWithItems: MultiSelectItem[];
  createdAt: DateRange | null;
  updatedAt: DateRange | null;
  lastActivityAt: DateRange | null;
  metrics: string[];
  sortBy: FlowSortBy;
  sortDirection: FlowSortDirection;
};
export type FlowFilterField = keyof FlowFilters;
export const initialFlowFilters: FlowFilters = {
  searchTerm: '',
  isStarred: null,
  isDueActions: null,
  isActivePeople: null,
  statuses: [FLOW_STATUS[0].value],
  labels: [],
  ownerIds: [],
  ownerItems: [],
  sharedWith: [],
  sharedWithItems: [],
  collections: [],
  collectionItems: [],
  createdAt: null,
  updatedAt: null,
  lastActivityAt: null,
  metrics: [],
  sortBy: 'name',
  sortDirection: 'ASC',
};

export type MoboUser = {
  id: number | string;
  name: string;
};
export type CurrentUser = {
  id: number | string;
  name: string;
  orgId: number | string;
};

export const DATE_RANGE = [
  {
    from: startOfQuarter(new Date()),
    to: new Date(),
    text: 'This Quarter',
  },
  {
    from: startOfMonth(new Date()),
    to: new Date(),
    text: 'This Month',
  },
  {
    from: subMonths(startOfMonth(new Date()), 1),
    to: subMonths(endOfMonth(new Date()), 1),
    text: 'Last Month',
  },
  {
    from: startOfWeek(new Date(), { weekStartsOn: 1 }),
    to: new Date(),
    text: 'This Week',
  },
  {
    from: new Date(),
    to: new Date(),
    text: 'Today',
  },
  {
    from: startOfWeek(subWeeks(new Date(), 1), { weekStartsOn: 1 }),
    to: endOfWeek(subWeeks(new Date(), 1), { weekStartsOn: 1 }),
    text: 'Last Week',
  },
  {
    from: subDays(new Date(), 6),
    to: new Date(),
    text: 'Last 7 Days',
  },
  {
    from: subDays(new Date(), 29),
    to: new Date(),
    text: 'Last 30 Days',
  },
  {
    from: subDays(new Date(), 90),
    to: new Date(),
    text: 'Last 90 Days',
  },
];
